import PropTypes from "prop-types"
import React from "react"
import Card from "semantic-ui-react/dist/es/views/Card/Card"

const CardGroup = ({ items, itemsPerRow, component, add, ...rest }) => {
  const Component = component
  const StaticCard = add
  return (
    <Card.Group itemsPerRow={itemsPerRow} stackable>
      {items.map(item => (
        <Card key={item.id} {...rest}>
          <Card.Content>
            <Component {...item} />
          </Card.Content>
        </Card>
      ))}
      <StaticCard />
    </Card.Group>
  )
}

CardGroup.propTypes = {
  items: PropTypes.array.isRequired,
  itemsPerRow: PropTypes.number,
  component: PropTypes.func.isRequired,
  add: PropTypes.func
}
CardGroup.defaultProps = {
  itemsPerRow: 2
}

export default CardGroup
